import {
  CardContent,
  CardHeader,
  CardTitle,
  Card,
  CardFooter,
} from '@packages/shared/src/ui/Card/Card';
import type { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { InputCurrency } from '@packages/shared/src/ui/Input/InputCurrency';
import { useFormatPrice } from '@packages/shared';
import { useFormContext } from 'react-hook-form';
import { generalFormMessages } from './messages';
import type { CreditCheckFormValues } from './schema';

type AdditionalCostsCardProps = {};
export const messages = defineMessages({
  cardTitle: {
    id: 'CreditCheckForm.AdditionalCostsCard.CardTitle',
    defaultMessage: 'Overige maandelijkse lasten',
  },
  loanFromFamily: {
    id: 'CreditCheckForm.AdditionalCostsCard.LoanFromFamily',
    defaultMessage: 'Leningen familie of vrienden *',
  },
  studentLoan: {
    id: 'CreditCheckForm.AdditionalCostsCard.StudentLoan',
    defaultMessage: 'Studieschuld *',
  },
  otherLoans: {
    id: 'CreditCheckForm.AdditionalCostsCard.OtherLoans',
    defaultMessage: 'Overige kredieten of leningen *',
  },
  monthlyLoanCosts: {
    id: 'CreditCheckForm.AdditionalCostsCard.MonthlyLoanCosts',
    defaultMessage: 'Alimentatie per maand *',
  },
});
export const AdditionalCostsCard: FC<AdditionalCostsCardProps> = () => {
  const { formatMessage } = useIntl();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<CreditCheckFormValues>();
  const { formatPrice } = useFormatPrice();

  const totalAmountAllLoans = [
    watch('firstPartForm.loanFromFamily'),
    watch('firstPartForm.studentLoan'),
    watch('firstPartForm.otherLoans'),
    watch('firstPartForm.monthlyLoanCosts'),
  ].reduce((acc, curr) => acc + (curr ? Number(curr) : 0), 0);

  return (
    <Card data-testid="additional-cost-card">
      <CardHeader hasDivider className="py-1">
        <CardTitle>{formatMessage(messages.cardTitle)}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 py-1.5 md:grid md:grid-cols-2 md:pb-2">
        <InputCurrency
          {...register('firstPartForm.loanFromFamily')}
          label={formatMessage(messages.loanFromFamily)}
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors.firstPartForm?.loanFromFamily?.message}
          helperText={errors.firstPartForm?.loanFromFamily?.message}
        />
        <InputCurrency
          {...register('firstPartForm.studentLoan')}
          label={formatMessage(messages.studentLoan)}
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors.firstPartForm?.studentLoan?.message}
          helperText={errors.firstPartForm?.studentLoan?.message}
        />
        <InputCurrency
          {...register('firstPartForm.otherLoans')}
          label={formatMessage(messages.otherLoans)}
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors.firstPartForm?.otherLoans?.message}
          helperText={errors.firstPartForm?.otherLoans?.message}
        />

        <InputCurrency
          {...register('firstPartForm.monthlyLoanCosts')}
          label={formatMessage(messages.monthlyLoanCosts)}
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors.firstPartForm?.monthlyLoanCosts?.message}
          helperText={errors.firstPartForm?.monthlyLoanCosts?.message}
        />
      </CardContent>
      <CardFooter hasDivider className="mx-2 px-0 py-1.5 font-bold md:justify-end">
        <div className="flex w-full justify-between md:w-1/2">
          <div className="">{formatMessage(generalFormMessages.totalText)}</div>
          <div>{formatPrice(totalAmountAllLoans * 100, 'EUR')}</div>
        </div>
      </CardFooter>
    </Card>
  );
};
